import {
    FETCH_TICKETORDERS,
    FETCH_VASORDERS,
    FETCH_LUCKMONEYORDERS,
    FETCH_REWARDORDERS,
    FETCH_MARKETORDERS,
    FETCH_ORDERS

} from '../actions/cmOrder';


export const initialState = {
    isFetching: true,
    data: null
};

export const ticketOrders = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_TICKETORDERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_TICKETORDERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const vasOrders = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_VASORDERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_VASORDERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
                addition: action.payload.addition,
            });
        default:
            return state;
    }
}

export const luckMoneyOrders = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_LUCKMONEYORDERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_LUCKMONEYORDERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const rewardOrders = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REWARDORDERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REWARDORDERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const marketOrders = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MARKETORDERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_MARKETORDERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const orders = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ORDERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ORDERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/cmOrder.js